import { AppThunkDispatch } from '@qwealth/qdata';
import { createAction, Dispatch } from '@reduxjs/toolkit';
import { errorHandler } from 'services/axiosService';
import { fetchKyps, searchKyps } from 'data/data-layer/kyp';
import { Kyp, KypDateField, KypFilters, KypSortOption } from 'data/models/Kyp';

const SET_KYPS = 'SET_KYPS';
const SET_IS_LOADING = 'SET_IS_LOADING';
const SET_HAS_ERROR = 'SET_HAS_ERROR';
const SET_SORT_BY = 'SET_SORT_BY';
const SET_SORTING_DATE = 'SET_SORTING_DATE';
const SET_SELECTED_KYP = 'SET_SELECTED_KYP';
const ADD_NEW_KYP = 'ADD_NEW_KYP';
const QUERY_KYPS = 'QUERY_KYPS';
const CLEAN_KYP = 'CLEAN_KYP';

export const setKyps = createAction<Kyp[]>(SET_KYPS);
export const queryKyps = createAction<Kyp[]>(QUERY_KYPS);
export const setIsLoading = createAction<boolean>(SET_IS_LOADING);
export const setHasError = createAction<boolean>(SET_HAS_ERROR);
export const setKypSortBy = createAction<KypSortOption | undefined>(SET_SORT_BY);
export const setKypSortingDate = createAction<KypDateField | undefined>(SET_SORTING_DATE);
export const setSelectedKyp = createAction<Kyp | undefined>(SET_SELECTED_KYP);
export const addNewKyp = createAction<Kyp>(ADD_NEW_KYP);
export const cleanKyp = createAction(CLEAN_KYP);

export const getKyps =
  (filters?: KypFilters) =>
  async (dispatch: AppThunkDispatch): Promise<Kyp[] | undefined> => {
    try {
      dispatch(setKypIsLoading(true));
      const kyps = await fetchKyps(filters);
      dispatch(setKypIsLoading(false));
      dispatch(setKyps(kyps));
      return kyps;
    } catch (error) {
      dispatch(setKypHasError(true));
      await errorHandler(dispatch, 'Error while loading KYPs')(error);
    }
  };

export const setKypIsLoading =
  (isLoading: boolean) =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(setIsLoading(isLoading));
  };

export const setKypHasError =
  (hasError: boolean) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(setHasError(hasError));
  };

export const unloadKypData =
  () =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(setKypIsLoading(false));
    dispatch(setKypHasError(false));
    dispatch(setKyps([]));
    dispatch(setSelectedKyp(undefined));
    dispatch(setKypSortBy(undefined));
    dispatch(setKypSortingDate(undefined));
  };

export const addKyp =
  (kyp: Kyp) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(addNewKyp(kyp));
  };

export const queryKyp =
  (query: string) =>
  async (dispatch: AppThunkDispatch): Promise<Kyp[]> => {
    dispatch(setKypIsLoading(true));
    const kyps = await searchKyps(query, dispatch);
    dispatch(setKyps(kyps));
    dispatch(setKypIsLoading(false));
    return kyps;
  };
